import "./ProductivityPage.scss";
import { DownOutlined, PieChartOutlined, DollarOutlined, BarChartOutlined, RiseOutlined, FallOutlined, LineChartOutlined } from "@ant-design/icons";
import { Button, Card, Row, Col, Flex, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatCurrency, formatWithCommas } from "../../assets/helpers";
import KpiCard from "../DashboardPage/components/KpiCard";
import PanelCard from "../DashboardPage/components/PanelCard";
import ActionHeader from "../../Reuseable/actionHeader/ActionHeader";
import ChartFilterModal from "../../Reuseable/actionHeader/ChartFilter";
import StackedBarChart from "../../Reuseable/StackedBar/StackedBarChart";
import {
  fetchProductivity,
  fetchProductivityDrrProjection,
} from "../../store/productivity";
import Donut from "./DonutChart/Donut";
import { ddrData, negativeData, positiveData } from "./productivityData";
import BarChartSkeleton from "../../Reuseable/Skeleton/BarchartSkeleton";

const ProductivityPage = () => {
  const [open, setOpen] = useState(false);

  const [primaryItems, setPrimaryItems] = useState([]);
  const [secondaryItems, setSecondaryItems] = useState([]);
  const [refresh, setRefresh] = useState(false);
    const { query } = useSelector((state) => state.filters);

  const { productivity, loading, drrProjection, drrProjectionLoading } =
    useSelector((state) => state.productivity);
  const { format } = useSelector((state) => state.priceFormat);
  const dispatch = useDispatch();
  const [selectedCategory, setSelectedCategory] = useState("team_member");
  const [selectedTrustMap, setSelectedTrustMap] = useState({
    team_member: [],
    team_leader: [],
  });

  useEffect(() => {
   if(Array.isArray(query?.trust_id)) {
     dispatch(fetchProductivity());
   }
  }, [dispatch,query]);

  useEffect(() => {
   
      if(Array.isArray(query?.trust_id)) {
     dispatch(fetchProductivityDrrProjection({ ...selectedTrustMap }));
   }
  }, [dispatch, refresh,query]);

  console.log(productivity,'productivity');
 

  return (
    <Card className="productivityPageMain">
      <ActionHeader
        heading="Productivity"
        primaryItems={primaryItems}
        secondaryItems={secondaryItems}
        setPrimaryItems={setPrimaryItems}
        showSecondaryItems={true}
        setSecondaryItems={setSecondaryItems}
        fetchData={fetchProductivity}
        fetchData2={fetchProductivityDrrProjection}
        setRefresh={setRefresh}
      />
      <div className="productivity_content">
        <Row gutter={[16, 16]}>
          {/* AUM Section */}
          <Col xs={24}>
            <PanelCard title="AUM Overview" icon={<PieChartOutlined />} accent="brand">
              <Row gutter={[16, 16]} align="middle">
                <Col xs={24} md={8}>
                  <KpiCard
                    title="AUM Value"
                    icon={<DollarOutlined />}
                    accent="brand"
                    loading={loading}
                    value={formatCurrency(productivity?.productivityS1?.aum, format)}
                  />
                </Col>
                <Col xs={24} md={8}>
                  <KpiCard
                    title="AUM Count"
                    icon={<BarChartOutlined />}
                    accent="blue"
                    loading={loading}
                    value={formatWithCommas(productivity?.productivityS1?.aum_count || 0)}
                  />
                </Col>
                <Col xs={24} md={8} style={{ display: 'flex', justifyContent: 'center' }}>
                  {loading ? (
                    <Skeleton.Avatar active shape="circle" size={120} />
                  ) : (
                    <Donut
                      series={[
                        productivity?.productivityS1?.pending_percentage || 0,
                        productivity?.productivityS1?.recovered_percentage || 0,
                      ]}
                    />
                  )}
                </Col>
              </Row>
            </PanelCard>
          </Col>

          {/* Positive Graph */}
          <Col xs={24} lg={12}>
            <PanelCard
              title="Positive"
              icon={<RiseOutlined />}
              accent="green"
              actions={
                <Flex gap={16} align="center" className="premium-stat-container">
                  <div className="premium-stat-badge">
                    <span className="premium-stat-label">Overall Value:</span>
                    <span className="premium-stat-value">
                      {formatCurrency(
                        productivity?.productivityS2?.action_code_summary
                          ?.positive_action_codes?.loans_amount,
                        format
                      )}
                    </span>
                  </div>
                  <div className="premium-stat-badge">
                    <span className="premium-stat-label">Count:</span>
                    <span className="premium-stat-value">
                      {formatWithCommas(
                        productivity?.productivityS2?.action_code_summary
                          ?.positive_action_codes?.count
                      )}
                    </span>
                  </div>
                </Flex>
              }
            >
              {loading ? (
                <BarChartSkeleton />
              ) : (
                <StackedBarChart
                  data={productivity?.productivityS2?.action_code_summary?.positive_action_codes?.items?.map(
                    (item) => ({
                      Positive: item?.loans_amount,
                      name: item?.action_code,
                      total_loans: item?.loans_amount,
                    })
                  )}
                  keys={positiveData?.keys}
                  tooltipType={"productivity"}
                  colors={positiveData?.colors}
                  keysVisible={false}
                  chartName="Portfolio"
                  yLabel=""
                  format_type="currency"
                  gridOptions={{
                    left: "0",
                    right: "0%",
                    bottom: "5%",
                    top: "10%",
                    stroke: "#E6E6E6",
                    strokeDasharray: "0",
                    vertical: false,
                  }}
                  margin={{ top: 0, right: 0, bottom: 3, left: 0 }}
                />
              )}
            </PanelCard>
          </Col>

          {/* Negative Graph */}
          <Col xs={24} lg={12}>
            <PanelCard
              title="Negative"
              icon={<FallOutlined />}
              accent="red"
              actions={
                <Flex gap={16} align="center" className="premium-stat-container">
                  <div className="premium-stat-badge">
                    <span className="premium-stat-label">Overall Value:</span>
                    <span className="premium-stat-value">
                      {formatCurrency(
                        productivity?.productivityS2?.action_code_summary
                          ?.negative_action_codes?.loans_amount,
                        format
                      )}
                    </span>
                  </div>
                  <div className="premium-stat-badge">
                    <span className="premium-stat-label">Count:</span>
                    <span className="premium-stat-value">
                      {formatWithCommas(
                        productivity?.productivityS2?.action_code_summary
                          ?.negative_action_codes?.count
                      )}
                    </span>
                  </div>
                </Flex>
              }
            >
              {loading ? (
                <BarChartSkeleton />
              ) : (
                <StackedBarChart
                  tooltipMode=""
                  data={productivity?.productivityS2?.action_code_summary?.negative_action_codes?.items?.map(
                    (item) => ({
                      Negative: item?.loans_amount,
                      name: item?.action_code,
                      total_loans: item?.loans_amount,
                    })
                  )}
                  keys={negativeData?.keys}
                  tooltipType={"productivity"}
                  colors={negativeData?.colors}
                  keysVisible={false}
                  chartName="Trust"
                  gridOptions={{
                    left: "0",
                    right: "0%",
                    bottom: "5%",
                    top: "10%",
                    stroke: "#E6E6E6",
                    strokeDasharray: "0",
                    vertical: false,
                  }}
                  format_type="currency"
                  margin={{ top: 0, right: 0, bottom: 3, left: 0 }}
                />
              )}
            </PanelCard>
          </Col>

          {/* DRR Projection */}
          <Col xs={24}>
            <PanelCard
              title="DRR Projection"
              icon={<LineChartOutlined />}
              accent="brand"
              actions={
                <Button
                  style={{ height: "35px", fontWeight: 500 }}
                  onClick={() => setOpen(true)}
                >
                  Filter <DownOutlined />
                </Button>
              }
            >
              {drrProjectionLoading ? (
                <BarChartSkeleton />
              ) : (
                <StackedBarChart
                  className="ddrProjectionMain"
                  data={drrProjection?.portfolios?.[0]?.months}
                  keys={["total", "target"]}
                  tooltipMode="weekly"
                  colors={["#FE7F49", "#00B247"]}
                  keysVisible={true}
                  yLabel=""
                  chartName="Months"
                  gridOptions={{
                    left: "0",
                    right: "0%",
                    bottom: "5%",
                    top: "10%",
                    stroke: "#E6E6E6",
                    strokeDasharray: "0",
                    vertical: false,
                  }}
                  height={200}
                  margin={{ top: 0, right: 0, bottom: 3, left: 0 }}
                  format_type="currency"
                  drr={true}
                  dualBar={true}
                />
              )}
            </PanelCard>
          </Col>
        </Row>
      </div>
      <ChartFilterModal
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        open={open}
        setOpen={setOpen}
        setSecondaryItems={setSecondaryItems}
        selectedTrustMap={selectedTrustMap}
        setSelectedTrustMap={setSelectedTrustMap}
        setRefresh={setRefresh}
      />
    </Card>
  );
};

export default ProductivityPage;
